import createVueComponent from '../createVueComponent';

const Circle = createVueComponent('CircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default Circle;
